import { FC, Fragment } from 'react'
import { RenderTranslatedFieldsProps } from '../../Forms.d'
import { Form, Tab, Tabs } from 'react-bootstrap'
import { useAppSelector } from '../../../../../store/hooks'
import { Language } from '../../../../../features/security/security.slice'
import TextField from '../TextField'
import TextAreaField from '../TextAreaField'
import SfyCKEditor from '../SfyCKEditor'

const RenderTranslatedFields: FC<RenderTranslatedFieldsProps> = ({
    id,
    fields,
    groupClassName,
    tabGroupClassName,
    tabContentClassName,
    formikProps,
    activeLocale,
}) => {
    const initData = useAppSelector((state: any) => state.security.initData)

    const renderFields = (lang: Language) => {
        return fields.map((field) => {
            const { errors } = formikProps
            const valueProp = `${field.name}_${lang.id}`
            const fieldId = `${field.id}_${lang.id}`

            return (() => {
                switch (field.type) {
                    case 'text':
                    case 'number':
                        return (
                            <TextField
                                key={field.id}
                                {...field}
                                id={fieldId}
                                name={valueProp}
                                formikProps={formikProps}
                            />
                        )
                    case 'textarea':
                        return (
                            <Fragment key={field.id}>
                                {field.enableEditor ? (
                                    <>
                                        {field.showLabel ===
                                        false ? null : (
                                            <Form.Label>
                                                {field.label}
                                            </Form.Label>
                                        )}
                                        <SfyCKEditor
                                            id={fieldId}
                                            name={valueProp}
                                            formikProps={formikProps}
                                        />
                                    </>
                                ) : (
                                    <TextAreaField
                                        key={field.id}
                                        {...field}
                                        id={fieldId}
                                        name={valueProp}
                                        formikProps={formikProps}
                                    />
                                )}
                                {errors[field.name] && (
                                    <Form.Text className="invalid-feedback">
                                        {errors[field.name].toString()}
                                    </Form.Text>
                                )}
                            </Fragment>
                        )
                    default:
                        return (
                            <Fragment key={field.id}>
                                Un-handled field type detected!
                            </Fragment>
                        )
                }
            })()
        })
    }

    if (activeLocale) {
        const lang: Language = initData.languages.data[activeLocale]
        if (!lang) return null

        return (
            <div className={groupClassName ? ' ' + groupClassName : ''}>
                {renderFields(lang)}
            </div>
        )
    }

    return (
        <div className={groupClassName ? ' ' + groupClassName : ''}>
            <Tabs
                id={id + '_RenderTranslatedFieldsTabs'}
                className={`mb-0 ${tabGroupClassName ? tabGroupClassName : ''}`}
            >
                {Object.keys(initData.languages.data).map((locale) => {
                    const lang: Language = initData.languages.data[locale]

                    return (
                        <Tab
                            eventKey={locale}
                            title={lang.name}
                            key={locale}
                            className={`fade border-start border-end border-bottom mb-3 p-2 in-tab-content ${
                                tabContentClassName ? tabContentClassName : ''
                            }`}
                        >
                            {renderFields(lang)}
                        </Tab>
                    )
                })}
            </Tabs>
        </div>
    )
}

export default RenderTranslatedFields
